export default function HeroData() {
  return {
    title: null,
    subtitle: "Protect Your Family<br>With Term Life Insurance",
    subtitleExtended: "Term life insurance is the most affordable<br>way to secure coverage.",
  }
}